/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import config from "config";
import Head from "next/head";
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";

import NewThemedLayout from "components/ThemedComponent/Common/NewThemedLayout";
import { useWindowResize } from "utils/hooks";
import { getUrlPath } from "utils/helpers";
import dynamic from "next/dynamic";
import TagManagerUtils from "utils/TagManager";
import { useRouter } from "next/router";
import { USER_PLATFORM } from "constants/tracking";
import {
	JobCity,
	JobArea,
	JobListJob,
	BreadCrumbDataType,
	JobCategory,
	FooterLinks,
} from "types/job";
import { TestimonialType } from "types/profile/ConnectionsType";
import { getFaqList } from "utils/JobListFaqUtils";
import getFooterContent from "utils/JobDetail/getFooterContent";
import useTrackWebSession from "hooks/useTrackWebSession";
import categoryData1 from "cms/category-data";
import departmentData from "cms/department-data";
import cityData1 from "cms/city-data";
import metaData from "cms/metadata-data";
import cityAreaMap from "cms/city-area-map";
import areaData1 from "cms/area-data";
import jobEntitiesData from "cms/job-entities-data";
import testimonialsData from "data/joblistTestimonials.json";
import { getFooterLinksV2 } from "utils/apiClients";
import {
	JOBS_PER_PAGE,
	BRANCH_APP_DOWNLOAD_CAMPAIGNS,
	PAGE_TYPES,
} from "utils/constants";
import { getJobListMetaData } from "utils/getMetadata";
import { createBranchDeepLink } from "libs/BranchIO";
import JobFeed from "components/JobListingPageComponents/JobFeed";
import ParseJobListSlug from "utils/newJobListSlugUtils";
import { JobCompany } from "types/job/JobCompany";
import { mxpTrackSection } from "components/ThemedComponent/mixPannelEvents";
import Layout from "components/Layout/Layoutv2";
import footerData from "cms/footer-data";
import { FooterData } from "types/job/FooterData";
import { JobDepartment } from "types/job/JobDepartment";
import { isOnboardingComplete, isUserLoggedIn } from "utils";
import FilterChipsNew from "components/JobListingPageComponents/FilterChipsNew";
import { getCandidateFeed, getWebConfigDetails } from "utils/apiClientPrivate";
import { useCandidateWebApplications } from "modules/candidate/profile/hooks/useCandidateWebApplications";
import {
	FilterChoice,
	FILTER_LABELS,
	getSelectedFiltersList,
} from "components/JobListingPageComponents/FiltersSidebar/index";
import { trackOnMixpanel } from "modules/candidate/profile/utils/MixpanelHelper";
import { useCandidateProgress } from "modules/candidate/profile/hooks/useCandidateProgress";
import { useCandidateProfile } from "modules/candidate/profile/hooks/useCandidateProfile";
import { useCandidateDetails } from "modules/candidate/profile/hooks/useCandidateDetails";
import { useJobDetails } from "modules/candidate/profile/hooks/useJobDetails";
import { SECTION_MAP } from "modules/candidate/profile/constants/sectionConstants";
import {
	generateSearchSessionID,
	getPrefilledLocation,
	getSearchEventProps,
	getSearchSessionID,
	setSearchEventProps,
} from "utils/commonUtils";
import { SEARCH_MP_EVENTS_PROPS_NAME } from "modules/candidate/profile/constants/mixpanelConstants";
import DesktopFilters from "components/RevampFeedDetails/JobFeed/components/DesktopFilters";
import UpdateProfileCard from "components/RevampFeedDetails/JobFeed/components/UpdateProfileCard";
import EditPreferencesCard from "components/RevampFeedDetails/JobFeed/components/EditPreferencesCard";
import useJobFeedStore from "components/RevampFeedDetails/JobFeed/store";
import useBranchIoLinkGeneration from "utils/BranchIO";
import styled from "styled-components";
import { bp } from "theme";
import {
	MIN_EXPERIENCE_DEFAULT_VALUE,
	PRE_APPLIED_FILTERS_FREQUENCY_KEY,
	VALUE_TO_LABEL_MAPPING,
} from "components/RevampFeedDetails/constants";
import { isCompanyNameExist } from "utils/dataHelperUtils/getCompanyNames";
import PreAppliedFilterCoachMark from "components/RevampFeedDetails/JobFeed/components/PreAppliedFilterCoachMark";
import clsx from "clsx";
import ExploreJobsInOthercity from "components/JobListingPageComponents/ExploreJobsInOtherCity/ExploreJobsInOthercity";
import { jobsListTransformer } from "utils/jobFeedApiParser";
import Banner from "components/JobListingPageComponents/Banner/Banner";
import { BannersResponse } from "components/JobListingPageComponents/Banner/types";
import { Correction } from "types/job/jobCorrectionType";
import { getFinalUrl } from "components/Search/Search";
import SearchCorrectionSubtitle from "components/Search/SearchCorrectionSubtitle";
import { FeedTab } from "types/job/jobFeedTabsType";
import { LoadingJobsCountTitle } from "components/JobListingPageComponents/JobFeedLoadingSkeleton";
import DiscoveryTabs from "components/DiscoveryFilters";

const FooterSeoContent = dynamic(() => import("components/FooterSeoContent"));

export const parseURLFilters = (filtersObject) => {
	const filtersToApply = [];
	Object.keys(filtersObject).forEach((key) => {
		// if (
		// 	key === "educationLevel" &&
		// 	Array.isArray(filtersObject[key]) &&
		// 	filtersObject[key].length > 0 &&
		// 	filtersObject[key]?.[0].level > 0
		// ) {
		// 	filtersToApply.push({
		// 		name: "education_level",
		// 		selected_value: filtersObject[key]?.[0].level,
		// 	});
		// }
		if (key === "postedIn" && filtersObject[key]) {
			filtersToApply.push({
				name: "posted_in",
				selected_value: filtersObject[key],
			});
		}
		if (key === "english_level" && filtersObject[key]) {
			filtersToApply.push({
				name: "english_level",
				selected_value: filtersObject[key],
			});
		}
		if (key === "gender" && filtersObject[key]) {
			filtersToApply.push({
				name: "gender",
				selected_value: filtersObject[key],
			});
		}
		if (key === "distance" && filtersObject[key]) {
			filtersToApply.push({
				name: "distance",
				selected_value: filtersObject[key],
			});
		}
		if (
			key === "min_experience" &&
			filtersObject[key] &&
			filtersObject[key] !== MIN_EXPERIENCE_DEFAULT_VALUE
		) {
			filtersToApply.push({
				name: "min_experience",
				selected_value: filtersObject[key],
			});
		}
		if (key === "salary" && filtersObject[key]) {
			filtersToApply.push({
				name: "salary",
				selected_value: filtersObject[key],
			});
		}
		if (key === "sortBy" && filtersObject[key]) {
			filtersToApply.push({
				name: "sort_by",
				selected_value: filtersObject[key],
			});
		}
		if (key === "featured_jobs" && filtersObject[key]) {
			filtersToApply.push({
				name: "featured_jobs",
				selected_value: true,
			});
		}
		if (
			key === "work_mode" &&
			Array.isArray(filtersObject[key]) &&
			filtersObject[key].length > 0
		) {
			filtersToApply.push({
				name: "work_mode",
				selected_value: filtersObject[key],
			});
		}
		if (
			key === "work_type" &&
			Array.isArray(filtersObject[key]) &&
			filtersObject[key].length > 0
		) {
			filtersToApply.push({
				name: "work_type",
				selected_value: filtersObject[key],
			});
		}
		if (
			key === "work_shift" &&
			Array.isArray(filtersObject[key]) &&
			filtersObject[key].length > 0
		) {
			filtersToApply.push({
				name: "work_shift",
				selected_value: filtersObject[key],
			});
		}
		if (
			key === "department" &&
			Array.isArray(filtersObject[key]) &&
			filtersObject[key].length > 0
		) {
			const departmentArray = [];
			filtersObject[key].forEach((department) => {
				if (department?.id > 0) {
					departmentArray.push(department?.id);
				}
			});
			if (departmentArray.length > 0)
				filtersToApply.push({
					name: "department_id",
					selected_value: departmentArray,
				});
		}
	});
	return filtersToApply;
};

const FiltersSidebar = dynamic(
	() => import("components/JobListingPageComponents/FiltersSidebar/index")
);

const SearchComponentMobile = dynamic(() => import("components/Search/SearchMobile"), {
	ssr: false,
});
type PreAppliedFilters = {
	name: string;
	selected_value: string;
};
export type JobsPropsType = {
	filters: {
		department: JobDepartment[];
		category: JobCategory[];
		city: JobCity[];
		area: JobArea[];
		location: {
			identifier: number;
			id: number;
			type: string;
			name: string;
		};
		jobTypes: any;
		company: JobCompany[];
		educationLevel: { level: number }[];
		gender: string;
		english_level: string;
		salary: string;
		workMode?: string[];
		workType?: string[];
		workShift?: string[];
		distance?: string;
		postedIn: number;
		min_experience: number;
		sortBy?: string;
		others?: string;
		searchEntity?: any;
		search?: boolean;
		job_title_slug?: string;
	};
	appliedFilterCount: number;
	categoryList: JobCategory[];
	departmentList: JobDepartment[];
	cityList: JobCity[];
	areaList: JobArea[];
	state: { id: number; name: string; slug: string };
	jobs: JobListJob[];
	testimonials: TestimonialType[];
	// eslint-disable-next-line react/require-default-props
	availableVendor?: string;
	pageNumber: number;
	pageName: string;
	slug: string;
	footerContent: any; // TODO: improve types
	slugEntitiesDetails: any;
	pageTitle: string;
	metaTitle: string;
	metaDescription: string;
	footerLinks: FooterLinks[];
	breadCrumbData: BreadCrumbDataType[];
	faqs: { question: string; answer: string }[];
	query: {
		page: number;
		page_size: number;
		wfh?: number;
		part_time?: number;
		experience?: string;
		shift?: string;
		gender?: string;
		english_level?: string;
		education_level?: number;
		category_id?: number;
		company_id?: string;
		city_id?: number;
		area_id?: number;
		state_id?: number;
		fall_back_type?: string;
		search?: boolean;
		entity_type?: string;
		entity_id?: number;
		text?: string;
		location_id: string;
		location_identifier: string;
		location_type: string;
		location_name: string;
	};
	totalJobCount: number;
	preAppliedFilters: PreAppliedFilters[];
	exploreByOtherCitiesData: any; // Add Types
	jobFeedPrefillData: any;
	paginationObject: any;
	bannersData: BannersResponse;
	correction: Correction | null;
	feed_tabs: FeedTab | [];
};

const Jobs: React.FC<JobsPropsType> = ({
	filters,
	areaList = [],
	jobs,
	testimonials,
	pageNumber,
	slug,
	appliedFilterCount,
	slugEntitiesDetails,
	state = null,
	faqs,
	query,
	totalJobCount = 0,
	footerContent,
	breadCrumbData,
	preAppliedFilters = [],
	exploreByOtherCitiesData,
	jobFeedPrefillData,
	paginationObject,
	bannersData,
	correction,
	feed_tabs,
	...props
}) => {
	const {
		setJobs,
		jobsInStore,
		jobsCount,
		totalJobsPages,
		setUrlSearchQuery,
		filters: desktopFilters,
		appliedFiltersCount: totalAppliedFilters,
		titleSearchObject,
		citySearchObject,
		appliedFilters,
		manualUserSearchInputs,
		setUrlPath,
		setSlugEntityDetails,
		setCitySearchObject,
		setTitleSearchObject,
		setExperienceSearchObject,
		setFiltersInitialState,
		setIsDesktopSearchExpanded,
		setJobFeedSearchInputPrefillData,
		experienceSearchObject,
		resetFilters,
		searchCorrectionObject,
		setSearchCorrectionObject,
		setSearchSessionId,
		setShowDiscoveryTabs,
		discoveryTabs,
		areJobsLoading,
	} = useJobFeedStore();
	const { page: desktopCurrentPage } = desktopFilters;
	const [isWebLoading, setWebLoading] = useState(false);
	const [hasUserScrolled, setHasUserScrolled] = useState(false);
	const isSearch = query?.search;
	/**
	 * We show footer content which is used for purely seo purpose only if url
	 * is for city level jobs only e.g jobs-in-mumbai
	 */
	const router = useRouter();
	const [activeFilter, setActiveFilterState] = useState(FilterChoice.SORT_BY);
	const {
		category,
		city,
		area,
		location,
		company,
		department,
		min_experience,
		searchEntity,
	} = filters;

	const [isMobileView] = useWindowResize();
	const { workFromHome, partTime, womenJobs, freshersJobs, nightShift } =
		filters.jobTypes;

	const [showPreAppliedFilterCoachMark, setShowPreAppliedFilterCoachMark] =
		useState(false);

	const updateFrequency = (newValue) => {
		localStorage.setItem(PRE_APPLIED_FILTERS_FREQUENCY_KEY, newValue.toString());
	};

	const hideTimeoutRef = useRef<NodeJS.Timeout | null>(null);

	const [isScrolling, setIsScrolling] = useState(false);
	const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		const handleScroll = () => {
			if (!isScrolling) {
				setIsScrolling(true);
			}

			if (scrollTimeoutRef.current) clearTimeout(scrollTimeoutRef.current);
			if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);

			// debounce scroll end
			scrollTimeoutRef.current = setTimeout(() => {
				setIsScrolling(false);
			}, 150);
		};

		window.addEventListener("scroll", handleScroll, { passive: true });

		return () => {
			window.removeEventListener("scroll", handleScroll);
			clearTimeout(scrollTimeoutRef.current);
			clearTimeout(hideTimeoutRef.current);
		};
	}, []);
	useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY > 75 + 170 + 90) {
				// 75 for jobs count section height, 170 for banner height, + 90 for Discovery Filters
				setHasUserScrolled(true);
			}
			if (window.scrollY <= 0) {
				setHasUserScrolled(false);
			}
		};
		if (isMobileView) window.addEventListener("scroll", handleScroll);

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);
	useEffect(() => {
		if (preAppliedFilters?.length) {
			const currentFrequency =
				parseInt(localStorage.getItem(PRE_APPLIED_FILTERS_FREQUENCY_KEY), 10) ||
				1;

			if (
				currentFrequency === 1 ||
				currentFrequency === 3 ||
				currentFrequency === 5
			) {
				setTimeout(() => {
					setShowPreAppliedFilterCoachMark(true);
				}, 1000);
			}
			if (currentFrequency <= 5) {
				updateFrequency(currentFrequency + 1);
			}
		}
	}, [preAppliedFilters?.length]);

	useEffect(() => {
		const filtersToApply = parseURLFilters(filters);

		if (min_experience && min_experience !== MIN_EXPERIENCE_DEFAULT_VALUE)
			setExperienceSearchObject({
				display_text: VALUE_TO_LABEL_MAPPING?.min_experience?.[min_experience],
				experience_input: min_experience,
			});
		// Handle pre-applied filters
		setFiltersInitialState([...preAppliedFilters, ...filtersToApply]);

		setJobFeedSearchInputPrefillData(jobFeedPrefillData);
		setJobs(jobs, paginationObject?.total_size || totalJobCount);
		setSearchCorrectionObject(correction);

		const hasFeedTabs = Array.isArray(feed_tabs) && feed_tabs.length > 0;
		const hasSlugEntities =
			Array.isArray(slugEntitiesDetails) && slugEntitiesDetails.length > 0;

		setShowDiscoveryTabs(hasFeedTabs && !hasSlugEntities);

		setUrlSearchQuery(query);
		setSlugEntityDetails(slugEntitiesDetails[0]);
		if (
			Array.isArray(slugEntitiesDetails) &&
			slugEntitiesDetails[0]?.type === "company"
		) {
			setUrlPath({
				company_id: slugEntitiesDetails[0]?.id,
			});
		}
		if (
			Array.isArray(slugEntitiesDetails) &&
			slugEntitiesDetails[0]?.type === "gender"
		) {
			setUrlPath({
				gender: slugEntitiesDetails[0]?.filter?.split("=").join("-"),
			});
		}
		if (filters?.job_title_slug) {
			setUrlPath({ job_title_slug: filters?.job_title_slug });
		}
		if (filters?.category[0]?.id > 0) {
			setUrlPath({ category_id: filters?.category[0]?.id });
		}
		// Parse city, area, location and search query data
		if (city[0]?.id > 0) {
			setCitySearchObject(city[0]);
		}
		// Check impact of change
		if (location?.id || location?.identifier) {
			setCitySearchObject(location);
		}
		if (searchEntity?.display_name) {
			if (searchEntity?.display_name !== titleSearchObject?.display_name)
				setTitleSearchObject(searchEntity);
		} else {
			setTitleSearchObject(null);
		}
	}, [filters]);
	useEffect(() => {
		// generate a new searchSessionId only when search is initiated
		if (isSearch) {
			const searchId = generateSearchSessionID();
			setSearchSessionId(searchId);
		}
	}, []);

	useEffect(() => {
		// For search pages, we want to keep the search bar in expanded state for logged in and logged out users.
		if (isSearch && !isMobileView) setIsDesktopSearchExpanded(true);
	}, [isSearch, isMobileView]);

	useLayoutEffect(() => {
		const searchEventObj = getSearchEventProps();
		if (
			!(searchEventObj && searchEventObj[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_SOURCE])
		) {
			const obj = {
				[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_SOURCE]: "Default",
			};
			const resObj = { ...searchEventObj, ...obj };
			// console.log("default", { resObj });
			setSearchEventProps(resObj);
		}
	}, []);
	const jobsData = jobs || jobsInStore || [];
	const { metaTitle, metaDescription, pageTitle, pageName, footerLinks } = props;

	useTrackWebSession(pageName);

	const isCityOnlyFeed = slugEntitiesDetails?.every((e) => e.type === "city");

	const [isShowFilterSidebar, setShowFilterSidebar] = useState(false);
	const [isShowSearchModal, setShowSearchModal] = useState(false);
	const { data: candidateProgressDetails, isLoading: isCandidateProgressLoading } =
		useCandidateProgress();
	const { data: candidateDetails } = useCandidateProfile(
		isCandidateProgressLoading
			? false
			: (candidateProgressDetails as any)?.isCandidateOnboardingCompleted
	);
	const { data: profileDetails, isLoading: isProfileDetailsLoading } =
		useCandidateDetails(candidateDetails?.phoneNumber);
	const { data: jobDetails } = useJobDetails(candidateDetails?.phoneNumber);
	const locationPref = jobDetails?.[SECTION_MAP.PROFILE_EDITOR]?.location_preference;
	const profileLocationDetails =
		profileDetails?.[SECTION_MAP.PROFILE_EDITOR]?.locationDetails;
	const isCandidateExperienced =
		profileDetails?.[SECTION_MAP.OVERALL]?.profileCardDetails?.isExperienced;

	const [downloadApnaLink, setDownloadApnaLink] = useState("");
	const {
		data: candidateJobApplicationDetails,
		isLoading: isCandidateJobApplicationDetailsLoading,
	} = useCandidateWebApplications();

	const hasAppliedJobOnWeb = useMemo(
		() =>
			isCandidateJobApplicationDetailsLoading
				? false
				: !!(candidateJobApplicationDetails as any)?.jobApplicationCount,
		[candidateJobApplicationDetails, isCandidateJobApplicationDetailsLoading]
	);
	useEffect(() => {
		const getDeepLink = async () => {
			const userId = localStorage.getItem("web_user_id");
			const connectDeepLink = await createBranchDeepLink({
				id: userId,
				section: "Track Application Banner",
				pageType: "Job Listing Page",
			});
			setDownloadApnaLink(connectDeepLink);
		};
		getDeepLink();

		if (router.query.sourcePage) {
			// To Do: Pass correct filter object
			trackOnMixpanel("Jobs Filtered Web", {
				"Selected Filters": getSelectedFiltersList(desktopFilters),
				Source: "Home Page",
				"No. of selected Filters": appliedFilterCount,
				"Distinct Jobs Shown": jobsCount,
			});
		}
		if (hasAppliedJobOnWeb) {
			trackOnMixpanel("Track your applications shown", {
				Screen: isJobFeedPage ? "Job Feed Web" : "Job Search Web",
			});
		} else
			trackOnMixpanel("Download app card shown", {
				Screen: isJobFeedPage ? "Job Feed Web" : "Job Search Web",
			});
	}, []);

	useEffect(() => {
		setTimeout(() => {
			if (hasAppliedJobOnWeb) {
				trackOnMixpanel("Track your applications shown", {
					Screen: isJobFeedPage ? "Job Feed Web" : "Job Search Web",
				});
			} else
				trackOnMixpanel("Download app card shown", {
					Screen: isJobFeedPage ? "Job Feed Web" : "Job Search Web",
				});
		}, 1000);
	}, []);
	useEffect(() => {
		// const searchEventObj = getSearchEventProps();
		const prefilledLocation = getPrefilledLocation();
		if (isJobFeedPage) {
			import("utils/Mixpanel").then((Mixpanel) => {
				Mixpanel.default.track("Job Feed Web", {
					"distinct jobs count": isMobileView ? totalJobCount : jobsCount,
					"Selected Filters": getSelectedFiltersList(desktopFilters),
					"Is filter applied": isMobileView
						? !!appliedFilterCount
						: !!appliedFilters.length,
					"filters auto applied": preAppliedFilters?.length > 0,
					"auto applied filters": preAppliedFilters,
				});
			});
			return;
		}

		trackOnMixpanel("Search Query Fetched Web", {
			num_main_bucket_jobs: totalJobCount,
			"Zero Search Results": totalJobCount <= 0,
			num_other_bucket_jobs: 0,
			"User Entered Query": query?.text || "",
			"Entity Type": filters?.searchEntity?.entity_type || null,
			"User Entered Location Query": location?.name
				? location?.name
				: city[0]?.name || "Anywhere in India",
			"Location Type": location?.type ? location?.type : city[0]?.type || "Custom",
			"Location Search Feature Used": "Default",
			Web_Job_Source: "Job Search Web",
			// "Search Method": filters?.searchEntity?.display_name
			// 	? "Keyword_Location"
			// 	: "Location_only",
			is_sorting_applied_search: isMobileView
				? !!filters?.sortBy
				: !!desktopFilters.sort_by,
			is_filter_applied_search: isMobileView
				? appliedFilterCount > 0
				: !!appliedFilters?.length,
			filters_applied: isMobileView
				? appliedFilterCount > 0
				: !!appliedFilters.length,
			page_no: isMobileView ? router.query?.page : desktopFilters?.page,
			Prefilled_Location: prefilledLocation,
			"Selected Filters": getSelectedFiltersList(desktopFilters),

			"Is filter applied": isMobileView
				? !!appliedFilterCount
				: !!appliedFilters.length,
			"filters auto applied": preAppliedFilters?.length > 0,
			"auto applied filters": preAppliedFilters,
			"User entered experience in years":
				min_experience !== MIN_EXPERIENCE_DEFAULT_VALUE ? min_experience : "N/A",
			"User entered experience":
				min_experience !== MIN_EXPERIENCE_DEFAULT_VALUE && !!min_experience,
			"Is experience filter manually applied": manualUserSearchInputs?.experience
				? !!manualUserSearchInputs?.experience
				: "No",
			"Is location filter manually applied": manualUserSearchInputs?.location
				? !!manualUserSearchInputs?.location
				: "No",
			"Auto Suggested keyword": searchCorrectionObject?.corrected_text,
			"Suggestion type": searchCorrectionObject
				? searchCorrectionObject?.is_implicit
					? "implicit"
					: "explicit"
				: "none",
			"auto suggested entity id":
				searchCorrectionObject?.suggestion?.entity_id || "",
			"auto suggested entity type":
				searchCorrectionObject?.suggestion?.entity_type || "",
			"Search ID": router?.query?.search ? getSearchSessionID() : "",
		});
	}, [filters]);

	const commonTrackingObj = {
		Source: props.pageName,
		city: city[0]?.name || "All",
		area: area[0]?.name || "All",

		category: category[0]?.type || "All",
		department: department[0]?.type || "All",
		state: state?.name || "All",
		// company: company[0]?.name || "All",
		isLoggedIn: false,
		selectedJobFeedType: null,
		userPlatform: USER_PLATFORM.apna,
		page: getUrlPath(),
	};

	const handleAllFiltersClick = () => {
		import("utils/Mixpanel").then((Mixpanel) => {
			Mixpanel.default.track(`Filter Chip Click`, {
				...commonTrackingObj,
				Section: mxpTrackSection.HERO_SECTION,
				currentFilter: "All",
				selectedFilter: "All",
				pageNo: pageNumber,
			});
		});
		setShowFilterSidebar(true);
		setActiveFilter(FilterChoice.SORT_BY);
	};

	useEffect(() => {
		// eslint-disable-next-line camelcase
		import("utils/Mixpanel").then((Mixpanel) => {
			Mixpanel.default.track("Page View", {
				Source: pageName,
				pageType: "Job List",
				city: city[0]?.name || "All",
				area: area[0]?.name || "All",
				category: category[0]?.name || "All",
				state: state?.name || "All",
				page: getUrlPath(),
				workFromHome: Boolean(workFromHome),
				partTime: Boolean(partTime),
				womenJob: Boolean(womenJobs),
				freshersJob: Boolean(freshersJobs),
			});
		});

		TagManagerUtils.addDataLayer({
			category: category[0]?.type,
			area: area[0]?.name,
			city: city[0]?.name,
			workFromHome: Boolean(workFromHome),
			partTime: Boolean(partTime),
			womenJob: Boolean(womenJobs),
			freshersJob: Boolean(freshersJobs),
			Source: pageName,
			state: state?.name,
			company: company[0]?.name,
		});
	}, []);

	const [downloadAppNowUrl] = useBranchIoLinkGeneration({
		id: null,
		campaign: BRANCH_APP_DOWNLOAD_CAMPAIGNS.downloadAppCTA,
		pageType: pageName,
		section: "Call HR Banner",
		custom_utm_medium: PAGE_TYPES.long,
	});
	const downloadAppClick = () => {
		trackOnMixpanel("Download app card clicked", {
			Screen: isJobFeedPage ? "Job Feed Web" : "Job Search Web",
		});
		window.open(downloadAppNowUrl as any, "_blank");
	};

	// This helps in closing the FilterSideBar Component on click of browser's back button
	useEffect(() => {
		router.beforePopState(({ as }) => {
			if (as !== router.asPath) {
				if (isShowFilterSidebar) {
					setShowFilterSidebar(false);
				}
				if (isShowSearchModal) {
					setShowSearchModal(false);
				}
			}
			return true;
		});

		return () => {
			router.beforePopState(() => true);
		};
	}, [router.query]);

	useEffect(() => {
		if (isShowFilterSidebar) {
			document.body.style.overflow = "hidden";
			// router.push("#");
		} else {
			document.body.style.overflow = "auto";
		}
	}, [isShowFilterSidebar]);

	useEffect(() => {
		if (isShowSearchModal) {
			document.body.style.overflow = "hidden";
			// router.push("#");
		} else {
			document.body.style.overflow = "auto";
		}
	}, [isShowSearchModal]);

	useEffect(() => {
		const handleRouteChangeStart = () => {
			setWebLoading(true);
		};

		const handleRouteChangeEnd = () => {
			setTimeout(() => {
				setWebLoading(false);
			}, 10);
		};

		router.events.on("routeChangeStart", handleRouteChangeStart);
		router.events.on("routeChangeComplete", handleRouteChangeEnd);
		router.events.on("routeChangeError", handleRouteChangeEnd);

		return () => {
			router.events.off("routeChangeStart", handleRouteChangeStart);
			router.events.off("routeChangeComplete", handleRouteChangeEnd);
			router.events.off("routeChangeError", handleRouteChangeEnd);
		};
	}, [router.events]);

	const setActiveFilter = (filterState: FilterChoice) => {
		setActiveFilterState(filterState);
		setShowFilterSidebar(true);
	};
	const filterChipsList = useMemo(() => {
		const searchChipsList = [
			{
				label: FILTER_LABELS[FilterChoice.EXPERIENCE],
				count:
					desktopFilters?.min_experience !== MIN_EXPERIENCE_DEFAULT_VALUE
						? 1
						: 0,
				onClick: () => setActiveFilter(FilterChoice.EXPERIENCE),
			},
			{
				label: FILTER_LABELS[FilterChoice.POSTED_IN],
				count: desktopFilters?.posted_in > 0 ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.POSTED_IN),
			},
			// For Search only add distance filter when search location query is non empty and of type "area"
			...((location?.type === "NBArea" || location?.type === "Area") &&
			location?.name !== ""
				? [
						{
							label: FILTER_LABELS[FilterChoice.DISTANCE],
							count: desktopFilters?.distance?.length ? 1 : 0,
							onClick: () => setActiveFilter(FilterChoice.DISTANCE),
						},
				  ]
				: []),
			{
				label: FILTER_LABELS[FilterChoice.SALARY],
				count: desktopFilters?.salary ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.SALARY),
			},
			{
				label: FILTER_LABELS[FilterChoice.EDUCATION],
				count: desktopFilters?.education_level ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.EDUCATION),
			},
			{
				label: FILTER_LABELS[FilterChoice.WORK_MODE],
				count: desktopFilters?.work_mode?.length || 0,
				onClick: () => setActiveFilter(FilterChoice.WORK_MODE),
			},
			{
				label: FILTER_LABELS[FilterChoice.WORK_TYPE],
				count: desktopFilters?.work_type?.length || 0,
				onClick: () => setActiveFilter(FilterChoice.WORK_TYPE),
			},
			{
				label: FILTER_LABELS[FilterChoice.WORK_SHIFT],
				count: desktopFilters?.work_shift?.length || 0,
				onClick: () => setActiveFilter(FilterChoice.WORK_SHIFT),
			},
			{
				label: FILTER_LABELS[FilterChoice.DEPARTMENT],
				count:
					desktopFilters?.department_id?.[0] !== -1
						? desktopFilters?.department_id?.length
						: 0,
				onClick: () => setActiveFilter(FilterChoice.DEPARTMENT),
			},
			{
				label: FILTER_LABELS[FilterChoice.ENGLISH],
				count: desktopFilters?.english_level !== "" ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.ENGLISH),
			},
			{
				label: FILTER_LABELS[FilterChoice.GENDER],
				count: desktopFilters?.gender !== "" ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.GENDER),
			},
			{
				label: FILTER_LABELS[FilterChoice.SORT_BY],
				count: desktopFilters?.sort_by !== "" ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.SORT_BY),
			},
			{
				label: FILTER_LABELS[FilterChoice.FEATURED],
				count: desktopFilters?.featured_jobs !== false ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.FEATURED),
			},
		];

		const feedChipsList = [
			{
				label: FILTER_LABELS[FilterChoice.POSTED_IN],
				count: desktopFilters?.posted_in > 0 ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.POSTED_IN),
			},
			// for FEED - only add distance filter when user is logged in and onboarded

			...(isUserLoggedIn() && isOnboardingComplete()
				? [
						{
							label: FILTER_LABELS[FilterChoice.DISTANCE],
							count: desktopFilters?.distance?.length ? 1 : 0,
							onClick: () => setActiveFilter(FilterChoice.DISTANCE),
						},
				  ]
				: []),
			{
				label: FILTER_LABELS[FilterChoice.SALARY],
				count: desktopFilters?.salary ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.SALARY),
			},
			{
				label: FILTER_LABELS[FilterChoice.WORK_MODE],
				count: desktopFilters?.work_mode?.length || 0,
				onClick: () => setActiveFilter(FilterChoice.WORK_MODE),
			},
			{
				label: FILTER_LABELS[FilterChoice.WORK_TYPE],
				count: desktopFilters?.work_type?.length || 0,
				onClick: () => setActiveFilter(FilterChoice.WORK_TYPE),
			},
			{
				label: FILTER_LABELS[FilterChoice.WORK_SHIFT],
				count: desktopFilters?.work_shift?.length || 0,
				onClick: () => setActiveFilter(FilterChoice.WORK_SHIFT),
			},
			{
				label: FILTER_LABELS[FilterChoice.DEPARTMENT],
				count:
					desktopFilters?.department_id?.[0] !== -1
						? desktopFilters?.department_id?.length
						: 0,
				onClick: () => setActiveFilter(FilterChoice.DEPARTMENT),
			},
			{
				label: FILTER_LABELS[FilterChoice.SORT_BY],
				count: desktopFilters?.sort_by !== "" ? 1 : 0,
				onClick: () => setActiveFilter(FilterChoice.SORT_BY),
			},
		];

		const list = isSearch ? searchChipsList : feedChipsList;
		const sortedList = list.sort((a, b) => b.count - a.count);

		return sortedList;
	}, [
		filters,
		desktopFilters,
		setActiveFilter,
		location,
		location.type,
		isSearch,
		isUserLoggedIn,
		isOnboardingComplete,
	]);

	/**
	 * In case a user is not logged in, we ought to return null
	 * when he momentarily lands on this page, before app level redirection
	 * kicks in, so that there's no CLS.
	 */

	if (!isUserLoggedIn() && !props.availableVendor) {
		return null;
	}
	const onPageinationClick = () => {
		if (window) {
			window.scrollTo({ top: 0, behavior: "smooth" });
		}
	};

	const handleSearchCorrection = () => {
		// Determine search text and query based on correction type
		const searchText = searchCorrectionObject?.is_implicit
			? query?.text
			: searchCorrectionObject?.text;
		const searchQuery = searchCorrectionObject?.is_implicit
			? query
			: searchCorrectionObject?.suggestion;

		const previousSearchSessionId = getSearchSessionID();
		const newSearchSessionId = generateSearchSessionID();

		trackOnMixpanel("search spellcheck correction clicked web", {
			"correction type": searchCorrectionObject?.is_implicit
				? "implicit"
				: "explicit",
			"user entered original query": query.text,
			"suggested query": searchCorrectionObject?.corrected_text,
			"user entered original location": location?.name || citySearchObject.name,
			num_main_bucket_jobs: totalJobCount,
			"orginal query entity": "",
			"suggested query entity":
				searchCorrectionObject?.suggestion?.entity_type || "",
			"Prev Search Id": previousSearchSessionId,
			"Search ID": newSearchSessionId,
		});

		resetFilters();

		// Generate final URL and navigate
		const url = getFinalUrl(
			searchQuery,
			citySearchObject,
			searchText,
			experienceSearchObject,
			searchCorrectionObject,
			newSearchSessionId
		);
		router.push(url);
	};

	const redirectToPlayStore = async () => {
		const { default: Mixpanel } = await import("utils/Mixpanel");
		Mixpanel.track("Track your applications clicked", {
			Screen: isJobFeedPage ? "Job Feed Web" : "Job Search Web",
		});
		window.open(downloadApnaLink);
	};

	const isJobFeedPage =
		!isSearch && slugEntitiesDetails?.length === 0 && !citySearchObject?.name;
	const getFilteredJobsTitle = (): string => {
		if (
			searchCorrectionObject &&
			Object.keys(searchCorrectionObject).length !== 0 &&
			!searchCorrectionObject?.is_implicit
		) {
			return "";
		}

		// title for implicit search corrections
		if (
			searchCorrectionObject &&
			Object.keys(searchCorrectionObject).length !== 0 &&
			isSearch &&
			searchCorrectionObject?.is_implicit
		) {
			return `Showing ${jobsCount} search results for ${searchCorrectionObject?.corrected_text}`;
		}
		if (
			router.query.featured_jobs === "true" &&
			totalAppliedFilters === 0 &&
			(jobsCount === 0 || jobsCount === null)
		) {
			return "Showing 0 jobs based on your profile";
		}
		if (totalAppliedFilters) {
			let title = `Showing ${jobsCount} ${
				jobsCount === 1 ? "job" : "jobs"
			} based on your `;
			title += totalAppliedFilters === 1 ? "filter" : "filters";
			return title;
		}
		const queryFilterKeys = Object.keys(router.query).filter(
			(key) => key !== "c_id" && key !== "source"
		);
		if (queryFilterKeys.length) {
			if (jobsCount) {
				let title = `${jobsCount} search `;
				title += jobsCount === 1 ? "result" : "results";
				return title;
			}
			return "";
		}
		let title = `Showing ${jobsCount} `;
		title += jobsCount <= 1 ? "job" : "jobs";
		title += " based on your profile";
		return title;
	};

	const renderShowingJobsInSubtitle = () => {
		const {
			cluster = {},
			area: defaultArea = {},
			city: defaultCity = {},
		} = locationPref?.default_location || {};

		if (cluster?.name) {
			return `Jobs near ${cluster?.name}`;
		}
		if (defaultArea?.name && defaultCity?.name) {
			return `Jobs near ${defaultArea?.name}, ${defaultCity?.name}`;
		}
		if (defaultCity?.name) {
			return `Jobs in ${defaultCity?.name}`;
		}
		if (defaultArea?.name) {
			return `Jobs near ${defaultArea?.name}`;
		}
		if (locationPref?.preferred_locations_v2?.[0]?.display_name)
			return `Jobs in  ${locationPref?.preferred_locations_v2?.[0]?.display_name}`;
		return "";
	};

	return (
		<NewThemedLayout availableVendor={props.availableVendor}>
			<Layout
				title={metaTitle}
				metaDescription={metaDescription}
				metaTitle={metaTitle}
				source={pageName}
				slug={`/candidate/jobs${slug ? `/${slug}` : ""}${
					pageNumber > 1 ? `?page=${pageNumber}` : ""
				}`}
				staticFooter={false}
				dynamicFooterLinks={footerLinks}
				activePage="job"
				image={undefined}
				ogUrl={undefined}
				customUtmMedium={undefined}
				isDark={false}
				pageNumber={pageNumber}
				availableVendor={props.availableVendor}
				removeMarginFromFooter
				isSearch={isSearch}
				isJobListingPage
			>
				<Head>
					{pageNumber > 1 && (
						<link
							rel="prev"
							href={`${config.websiteUrl.slice(0, -1)}/candidate/jobs${
								slug ? `/${slug}` : ""
							}${pageNumber - 1 > 1 ? `?page=${pageNumber - 1}` : ""}`}
						/>
					)}
					{pageNumber < totalJobsPages && (
						<link
							rel="next"
							href={`${config.websiteUrl.slice(0, -1)}/candidate/jobs${
								slug ? `/${slug}` : ""
							}?page=${pageNumber + 1}`}
						/>
					)}
					<link rel="alternate" href="android-app://com.apnatime" />
				</Head>
				{/* Mobile -> Search and filters */}
				<div
					className={clsx(
						"sticky top-16 z-10 block bg-white pb-[8px] shadow-sm md:hidden",
						{
							"z-[9999]": showPreAppliedFilterCoachMark,
							"bg-white": showPreAppliedFilterCoachMark,
							"!bg-transparent":
								isScrolling && hasUserScrolled && !isSearch,
							"pointer-events-none": showPreAppliedFilterCoachMark,
						}
					)}
				>
					<SearchComponentMobile
						isShowSearchModal={isShowSearchModal}
						setShowSearchModal={setShowSearchModal}
					/>
					{isMobileView &&
						!isWebLoading &&
						!isProfileDetailsLoading &&
						!isCandidateProgressLoading && (
							<PreAppliedFilterCoachMark
								isOpen={showPreAppliedFilterCoachMark}
								handleClose={() => {
									setShowPreAppliedFilterCoachMark(false);
								}}
							/>
						)}
					<div
						className={clsx("max-w-[1040px] md:mx-auto md:mb-6", {
							hidden: hasUserScrolled,
						})}
					>
						{isUserLoggedIn() &&
							isMobileView &&
							!isSearch &&
							Array.isArray(bannersData?.banners) &&
							bannersData?.banners?.length > 0 && (
								<Banner bannersResponse={bannersData} />
							)}
					</div>
					<DiscoveryTabs />
					<div className="h-[48px] overflow-hidden bg-transparent transition-all duration-300 ease-in-out">
						<div
							className={clsx("transition-all duration-300 ease-in-out", {
								"pointer-events-none -translate-y-2 opacity-0":
									isScrolling && hasUserScrolled && !isSearch,
								"translate-y-0 opacity-100": !isScrolling,
							})}
						>
							<FilterChipsWrapper>
								<FilterChipsNew
									handleAllFiltersClick={handleAllFiltersClick}
									filterObj={filterChipsList}
									isDesktopView={!isMobileView}
									areFiltersPreApplied={preAppliedFilters?.length > 0}
									showPreAppliedCoachMark={
										showPreAppliedFilterCoachMark
									}
									departmentObject={department}
								/>
							</FilterChipsWrapper>
						</div>
					</div>
					<div>
						{areJobsLoading ? (
							<span className={clsx({ hidden: hasUserScrolled })}>
								<LoadingJobsCountTitle />
							</span>
						) : (
							<div
								className={clsx({
									"mx-[12px] my-[8px]": isMobileView,
									block:
										discoveryTabs?.activeTabId &&
										discoveryTabs?.showTabs,
									hidden: hasUserScrolled && !isSearch,
								})}
								data-testid="search-result-title-container-mweb"
							>
								<p className="m-0 text-md font-semibold leading-[24px] text-[#190A28] md:mx-0 md:text-xl md:font-bold md:leading-[28px]">
									{getFilteredJobsTitle()}
								</p>
								{isJobFeedPage && renderShowingJobsInSubtitle() && (
									<p className="m-0 text-xs leading-[16px] text-[#827485] md:mx-0 md:text-sm md:leading-[20px]">
										{renderShowingJobsInSubtitle()}{" "}
									</p>
								)}
								{isSearch && searchCorrectionObject?.sub_title && (
									<p className="m-0 text-xs leading-[16px] text-[#827485] md:mx-0 md:text-sm md:leading-[20px]">
										<SearchCorrectionSubtitle
											correction={searchCorrectionObject}
											handleSearchCorrection={
												handleSearchCorrection
											}
											query={query}
										/>
									</p>
								)}
							</div>
						)}
					</div>
				</div>
				{isUserLoggedIn() &&
					!isMobileView &&
					!isSearch &&
					Array.isArray(bannersData?.banners) &&
					bannersData?.banners?.length > 0 && (
						<Banner bannersResponse={bannersData} />
					)}
				<div
					data-testid="search-result-title-container-web"
					className="m-[12px] mt-[24px] hidden max-w-[1040px] md:mx-auto md:mb-6 md:block"
				>
					<DiscoveryTabs />

					<div>
						{areJobsLoading ? (
							<LoadingJobsCountTitle />
						) : (
							<div
								className={clsx({
									"mx-[12px] my-[8px]": isMobileView,
									block:
										discoveryTabs?.activeTabId &&
										discoveryTabs?.showTabs,
								})}
								data-testid="search-result-title-container-mweb"
							>
								<p className="m-0 text-md font-semibold leading-[24px] text-[#190A28] md:mx-0 md:text-xl md:font-bold md:leading-[28px]">
									{getFilteredJobsTitle()}
								</p>
								{isJobFeedPage && renderShowingJobsInSubtitle() && (
									<p className="m-0 text-xs leading-[16px] text-[#827485] md:mx-0 md:text-sm md:leading-[20px]">
										{renderShowingJobsInSubtitle()}{" "}
									</p>
								)}
								{isSearch && searchCorrectionObject?.sub_title && (
									<p className="m-0 text-xs leading-[16px] text-[#827485] md:mx-0 md:text-sm md:leading-[20px]">
										<SearchCorrectionSubtitle
											correction={searchCorrectionObject}
											handleSearchCorrection={
												handleSearchCorrection
											}
											query={query}
										/>{" "}
									</p>
								)}
							</div>
						)}
					</div>
				</div>
				<div className="mx-auto grid max-w-[1040px] grid-cols-1 md:mb-16 md:grid-cols-4 md:gap-[16px]">
					{/* Filters Section for Desktop */}
					<div
						className={`col-span-1 hidden md:block ${
							jobsData?.length > 0
								? "md:max-h-[4500px] md:min-h-[1880px]"
								: "md:h-[1880px]"
						}`}
					>
						<DesktopFilters
							showPreAppliedFilterCoachMark={showPreAppliedFilterCoachMark}
							setShowPreAppliedFilterCoachMark={
								setShowPreAppliedFilterCoachMark
							}
							isDataLoading={
								isWebLoading ||
								isCandidateProgressLoading ||
								isProfileDetailsLoading
							}
							location={location}
						/>
					</div>
					{/* Feed For Desktop and Mobile */}
					<div className="col-span-1 h-full md:col-span-2">
						<JobFeed
							pageName={pageName}
							slug={slug}
							selectedState={state}
							isCityOnlyFeed={isCityOnlyFeed}
							filterStates={filters}
							pageNumber={desktopCurrentPage}
							filterCount={appliedFilterCount}
							search={filters?.search}
							onPageinationClick={onPageinationClick}
							isJobFeedPage={isJobFeedPage}
							isCandidateExperienced={isCandidateExperienced}
						/>
						<ExploreJobsInOthercity data={exploreByOtherCitiesData} />
					</div>
					{/* Banners Section */}
					<div
						className={`mb-[12px] space-y-[16px] bg-[#F4F2F6] p-[16px] md:col-span-1 ${
							jobsData?.length > 0
								? "md:max-h-[4500px] md:min-h-[1880px]"
								: "md:h-[1880px]"
						} md:p-0`}
					>
						<div className="hidden space-y-[16px] md:block">
							<UpdateProfileCard userData={profileDetails} />
							{!isProfileDetailsLoading &&
								!isCandidateExperienced &&
								isCandidateExperienced !== undefined && (
									<EditPreferencesCard
										jobDetails={jobDetails}
										isJobFeedPage={isJobFeedPage}
									/>
								)}
						</div>
						{/* Revamp-todo: add deep link for each banner */}
						<div className="h-full w-full space-y-[16px] rounded-xl">
							{hasAppliedJobOnWeb && !props.availableVendor && (
								<div
									className="relative w-full cursor-pointer"
									onClick={redirectToPlayStore}
								>
									{!isMobileView ? (
										<picture>
											<source
												srcSet="https://storage.googleapis.com/mumbai_apnatime_prod/jobs_page/TrackForDesktop.webp"
												type="image/webp"
											/>
											<img
												src="https://storage.googleapis.com/mumbai_apnatime_prod/jobs_page/TrackForDesktop_p.png"
												alt="Location Pin Icon"
												className="h-auto w-auto  md:h-[412px] md:w-[248px]"
											/>
										</picture>
									) : (
										<picture>
											<source
												srcSet="https://storage.googleapis.com/mumbai_apnatime_prod/jobs_page/TrackForMobile.webp"
												type="image/webp"
											/>
											<img
												src="https://storage.googleapis.com/mumbai_apnatime_prod/jobs_page/TrackForMobile_p.png"
												alt="Location Pin Icon"
												className="h-auto w-auto  md:h-[412px] md:w-[248px]"
											/>
										</picture>
									)}
								</div>
							)}
							{!hasAppliedJobOnWeb && (
								<div
									className="relative w-full cursor-pointer"
									onClick={downloadAppClick}
								>
									{!isMobileView ? (
										<picture>
											<source
												srcSet="https://storage.googleapis.com/mumbai_apnatime_prod/jobs_page/DownloadForDesktop.webp"
												type="image/webp"
											/>
											<img
												src="https://storage.googleapis.com/mumbai_apnatime_prod/jobs_page/DownloadForDesktop_p.png"
												alt="Location Pin Icon"
												className="h-auto w-auto  md:h-[412px] md:w-[248px]"
											/>
										</picture>
									) : (
										<picture>
											<source
												srcSet="https://storage.googleapis.com/mumbai_apnatime_prod/jobs_page/DownloadForMobile.webp"
												type="image/webp"
											/>
											<img
												src="https://storage.googleapis.com/mumbai_apnatime_prod/jobs_page/DownloadForMobile_p.png"
												alt="Location Pin Icon"
												className="h-auto w-auto  md:h-[412px] md:w-[248px]"
											/>
										</picture>
									)}
								</div>
							)}
						</div>
					</div>
				</div>
				{slugEntitiesDetails?.length > 0 && (
					<FooterSeoContent
						content={footerContent}
						jobType={workFromHome ? "wfh" : ""}
					/>
				)}
			</Layout>
			<FiltersSidebar
				closeSidebar={() => {
					setShowFilterSidebar(false);
				}}
				activeFilterState={activeFilter}
				isShowFilterSidebar={isShowFilterSidebar}
				departmentObject={department}
			/>
			{/* <MobileWebToAppBanner>
				{showWebToAppOverlay && (
					<WebToAppBanner
						showOverlay={showWebToAppOverlay}
						onClose={(e) => {
							setShowWebToAppOverlay(false);
							localStorage.setItem(WEB_TO_APP_BANNER_SHOWN, "true");
							bannerTrackingEvent("Continue in Browser Clicked");
							e.stopPropagation();
						}}
						onBackDropClick={() => {
							setShowWebToAppOverlay(false);
							localStorage.setItem(WEB_TO_APP_BANNER_SHOWN, "true");
							bannerTrackingEvent("Web to app banner closed - out click");
						}}
						imageSrc="/cloudinary/profile_page_images/Call-HR.jpg"
						title={`Checkout 1000+ jobs on apna ${pageNameOnBanner()} and book your job interview in 15 minutes`}
						onCTAClick={() => {
							bannerTrackingEvent("App Open Clicked");
							openInAPP();
						}}
					/>
				)}
			</MobileWebToAppBanner> */}
		</NewThemedLayout>
	);
};
const FilterChipsWrapper = styled.div`
	max-width: 1040px;
	margin: 0 auto;
	position: sticky;
	top: 0;
	z-index: 10;
	background: #fff;
	${bp.md} {
		margin-top: 16px;
		position: static;
	}
`;

// const MobileWebToAppBanner = styled.div`
// 	display: block;
// 	position: sticky;
// 	bottom: 0;
// 	z-index: 21;
// 	${bp.md} {
// 		display: none;
// 	}
// `;

export default Jobs;

export const getServerSideProps = async ({ params, query, res }) => {
	const { paths } = params;
	const slug = paths ? paths[0] : "";

	const pageNumber = query?.page ? parseInt(query?.page as string, 10) : 1;
	const availableVendor =
		query?.source && query.source !== "false" ? query?.source : null;

	// If we do not get categorydata or area data we redirect user to  404 page
	// this check is added just in case if category data or area data api fails for some reason

	// if (categoryData1?.length === 0 || areaData1.length === 0 || metaData.length === 0) {
	// 	return {
	// 		notFound: true,
	// 	};
	// }

	const allObjectNew = {
		id: -1,
		type: "All",
		slug: "all",
		job_count: { total_jobs: 0, total_no_of_openings: 0 },
	};

	const defaultParamValue = {
		id: -1,
		name: "All",
		slug: "all",
	};

	const defaultArea = {
		id: -1,
		name: "All",
		slug: "all",
	};

	const defaultCity = {
		id: -1,
		name: "Anywhere in India",
		slug: "all",
	};

	let props = {
		filters: {
			city: [defaultCity],
			area: [defaultArea],
			location: { id: null, type: "", name: "", identifier: "" },
			category: [allObjectNew],
			department: [allObjectNew as unknown as JobDepartment],
			jobTypes: {
				partTime: 0,
				workFromHome: 0,
				nightShift: 0,
				freshersJobs: 0,
				womenJobs: 0,
			},
			salary: [],
			distance: "",
			postedIn: 0,
			educationLevel: [{ level: 0 }],
			company: [defaultParamValue],
			gender: "",
			english_level: "",
			searchEntity: null,
			search: false,
			job_title_slug: "",
			featured_jobs: false,
		},
		appliedFilterCount: 0,
		totalJobCount: 0,
		jobs: [],
		cityList: [defaultCity, ...(cityData1 as any)],
		categoryList: [allObjectNew, ...(categoryData1 as unknown as JobCategory[])],
		departmentList: [allObjectNew, ...(departmentData as unknown as JobDepartment[])],
		areaList: [],
		metaTitle: "",
		metaDescription: "",
		pageName: "Job Listing Page",
		isFallback: false,
		totalOpenings: 0,
		typeName: "",
		pageTitle: "",
		filter: {},
		totalPages: 0,
		breadCrumbData: null,
		slug,
		pageNumber,
		footerContent: {},
		footerLinks: [],
		slugEntitiesDetails: [],
		testimonials: [],
		state: defaultParamValue,
		availableVendor: null,
		faqs: [],
		query,
		exploreByOtherCitiesData: {},
		jobFeedPrefillData: {},
		bannersData: {},
		correction: {},
		feed_tabs: {},
	};
	const { slugEntitiesDetails, filters, propsData, parsingFailed } = ParseJobListSlug(
		slug,
		pageNumber,
		JOBS_PER_PAGE,
		query,
		cityAreaMap,
		areaData1,
		jobEntitiesData,
		categoryData1,
		departmentData
	);
	if (!parsingFailed) {
		props = { ...props, ...propsData };
		props.filter = { ...query, ...filters };
		let appliedFilters = 0;
		// if (
		// 	propsData?.filters?.jobTypes?.freshersJobs ||
		// 	propsData?.filters?.jobTypes?.nightShift ||
		// 	propsData?.filters?.jobTypes?.partTime ||
		// 	propsData?.filters?.jobTypes?.womenJobs ||
		// 	propsData?.filters?.jobTypes?.workFromHome
		// ) {
		// 	appliedFilters += 1;
		// }

		if (
			propsData?.filters?.department?.length > 0 &&
			propsData?.filters?.department?.[0]?.id !== -1
		) {
			appliedFilters += 1;
		}

		if (propsData?.filters?.workMode?.length > 0) {
			appliedFilters += 1;
		}

		if (propsData?.filters?.workType?.length > 0) {
			appliedFilters += 1;
		}

		if (propsData?.filters?.workShift?.length > 0) {
			appliedFilters += 1;
		}

		if (propsData?.filters?.educationLevel[0]?.level > 0) {
			appliedFilters += 1;
		}

		// if (propsData?.filters?.company[0]?.id !== -1) {
		// 	appliedFilters += 1;
		// }

		if (propsData?.filters?.salary?.length > 0) {
			appliedFilters += 1;
		}

		if (propsData?.filters?.distance?.length > 0) {
			appliedFilters += 1;
		}

		if (propsData?.filters?.postedIn > 0 || propsData?.filters?.postedIn === -1) {
			appliedFilters += 1;
		}
		if (
			propsData?.filters?.min_experience >= 0 &&
			propsData?.filters?.min_experience !== MIN_EXPERIENCE_DEFAULT_VALUE
		) {
			appliedFilters += 1;
		}

		if (propsData?.filters?.sortBy !== "") {
			appliedFilters += 1;
		}
		if (propsData?.filters?.gender !== "") {
			appliedFilters += 1;
		}
		if (propsData?.filters?.english_level !== "") {
			appliedFilters += 1;
		}

		// if (propsData?.filters?.others !== "") {
		// 	appliedFilters += 1;
		// }
		props.appliedFilterCount = appliedFilters;

		// props.breadCrumbData = buildBreadCrumbsData(slugEntitiesDetails);

		const footerContent = getFooterContent(
			footerData as unknown as FooterData,
			slugEntitiesDetails
		);
		// When user is coming from navlinks.
		// We are constructing search query to treat nav links company links as search pages
		if (props.filter?.company_id) {
			const company = isCompanyNameExist(slug.replace("-jobs", ""));
			props.filter = {
				...props.filter,
				// location_id: "1",
				// location_identifier: "1",
				// location_name: "Anywhere in India",
				// location_type: "CustomLocation",
				search: true,
				entity_id: props.filter?.company_id,
				entity_type: "Organization",
				text: company?.name || "",
			};

			props.query = {
				...props.query,
				// location_id: "1",
				// location_identifier: "1",
				// location_name: "Anywhere in India",
				// location_type: "CustomLocation",
				search: true,
				entity_id: props.filter?.company_id,
				entity_type: "Organization",
				text: company?.name || "",
			};

			props.filters = {
				...props.filters,
				// location: {
				// 	id: "1",
				// 	identifier: "1",
				// 	name: "Anywhere in India",
				// 	type: "CustomLocation",
				// },
				searchEntity: {
					entity_id: props.filter?.company_id,
					entity_type: "Organization",
					display_name: company?.name || "",
				},
				search: true,
			};
		}
		/*
			If there is no search query and we have not come to jobs page from Navbar links,
			we will make an API call for config, which will give us the default search query.
			We will set the default search query in props.
			This is implemented for fresher users whose default page is search listing.
		*/
		let firstCall = false;
		let configDetails = {};

		if (
			!query?.search &&
			!query?.location_id &&
			!query?.location_identifier &&
			!query?.location_name &&
			!query?.text &&
			!query?.entity_type &&
			!props.filter?.city_id &&
			!props.filter?.department_id &&
			!props.filter?.work_type &&
			!props.filter?.experience &&
			!props.filter?.work_shift &&
			!props.filter?.others &&
			!props.filter?.work_mode &&
			!props.filter?.company_id &&
			!props.filter?.education_level &&
			!props.filter?.category_id
		) {
			try {
				configDetails = await getWebConfigDetails(props.filter);
				if (configDetails?.landingPage !== "job_feed") firstCall = true;
			} catch (e) {
				console.log("error", e);
			}
		}
		props.footerContent = footerContent || null;
		props.slugEntitiesDetails = slugEntitiesDetails;

		const updatedLocationObject = Object.keys(
			configDetails?.searchQuery?.location || {}
		).reduce((acc, key) => {
			acc[`location_${key}`] = configDetails.searchQuery.location[key];
			return acc;
		}, {});

		const updatedKeywordObject = {};
		Object.keys(configDetails?.searchQuery?.keyword || {}).forEach((key) => {
			if (key === "display_name") {
				updatedLocationObject.text = configDetails.searchQuery.keyword[key];
			} else if (configDetails.searchQuery.keyword[key] !== null) {
				updatedLocationObject[key] = configDetails.searchQuery.keyword[key];
			}
		});
		const minExperienceObject = {};
		Object.keys(configDetails?.searchQuery?.user_experience || {}).forEach((key) => {
			if (key === "experience_input") {
				minExperienceObject.min_experience =
					configDetails.searchQuery.user_experience[key];
			}
		});

		// We will update query object for jobs API with the search related entities received in config API.
		if (
			firstCall &&
			(configDetails?.searchQuery?.keyword?.entity_id ||
				configDetails?.searchQuery?.location?.identifier ||
				configDetails?.searchQuery?.user_experience?.experience_input)
		) {
			props.filter = {
				...props.filter,
				...updatedKeywordObject,
				...updatedLocationObject,
				...minExperienceObject,
				search: true,
			};
			props.filters = {
				...props.filters,
				location: {
					...configDetails?.searchQuery?.location,
				},
				searchEntity: {
					...configDetails?.searchQuery?.keyword,
				},
				...minExperienceObject,
				search: true,
			};
			props.query = {
				...query,
				...updatedKeywordObject,
				...updatedLocationObject,
				...minExperienceObject,
				search: true,
			};
		}
		//  For feed, we send prefill data for search inputs to client.
		if (
			!firstCall &&
			configDetails?.landingPage === "job_feed" &&
			(configDetails?.searchQuery?.keyword?.entity_id ||
				configDetails?.searchQuery?.location?.identifier ||
				configDetails?.searchQuery?.user_experience?.experience_input)
		) {
			props.jobFeedPrefillData = {
				location: {
					...configDetails?.searchQuery?.location,
				},
				searchEntity: {
					...configDetails?.searchQuery?.keyword,
				},
				...minExperienceObject,
			};
		}
		if (query?.raw_text_correction) {
			props.filter = {
				...props.filter,
				raw_text_correction: query?.raw_text_correction,
			};
		}

		try {
			const [jobResp, footerLinks] = await Promise.all([
				getCandidateFeed(props.filter, firstCall),
				getFooterLinksV2(props.filter),
			]);

			props.bannersData = jobResp.data.results.banners_response;
			props.footerLinks = footerLinks.data;
			props.correction = jobResp?.data?.results?.raw_text_correction;
			try {
				const faqs = getFaqList({
					city:
						propsData?.filters?.city[0]?.id === -1
							? undefined
							: propsData?.filters?.city[0],
					area:
						propsData?.filters?.area[0]?.id === -1
							? undefined
							: propsData?.filters?.area[0],
					category:
						propsData?.filters?.category[0]?.id === -1
							? undefined
							: propsData?.filters?.category[0],
					department:
						propsData?.filters?.department[0]?.id === -1
							? undefined
							: propsData?.filters?.department[0],
					footerLinks: footerLinks?.data,
				});

				props.faqs = faqs || [];
			} catch (e) {
				// eslint-disable-next-line no-console
				console.log(e, "faq error occured");
			}
			if (jobResp.status === 200) {
				// Get transformed jobs array and pagination object (for job feed)
				const { jobsList, pagination } = jobsListTransformer(
					jobResp?.data?.results
				);
				// new props setup
				props.exploreByOtherCitiesData =
					jobResp?.data?.results?.explore_jobs_in_other_cities || {};
				props.totalJobCount = jobResp?.data?.count || pagination?.total_size || 0;
				props.totalPages = Math.ceil(props.totalJobCount / JOBS_PER_PAGE);
				props.totalOpenings =
					jobResp?.data?.results?.total_no_of_openings || props.totalJobCount;
				props.jobs = jobsList || [];
				props.paginationObject = pagination || null;
				props.isFallback = jobResp?.data?.results?.fall_back === "apply";
				props.typeName = jobResp?.data?.results?.type || "";
				props.feed_tabs = jobResp.data?.results?.feed_tabs;
				const { metaTitle, metaDescription, pageTitle, pageName } =
					await getJobListMetaData(
						slugEntitiesDetails,
						metaData,
						props.totalJobCount,
						slug
					);

				props.metaDescription = metaDescription;
				props.metaTitle = metaTitle;
				props.pageName = pageName;
				props.pageTitle = pageTitle;
				const preAppliedFiltersArray =
					jobResp?.data?.results?.preapplied_filters || [];
				const preAppliedFiltersObject = {};
				preAppliedFiltersArray.forEach((filter) => {
					if (filter.name === "education_level") {
						preAppliedFiltersObject.educationLevel = [
							{ level: filter.selected_value },
						];
					} else preAppliedFiltersObject[filter.name] = filter.selected_value;
				});
				// If firstcall is true, we will get some preselected filters.
				if (jobResp?.data?.results?.preapplied_filters) {
					// For desktop filters
					props.preAppliedFilters = jobResp?.data?.results?.preapplied_filters;
					props.appliedFilterCount +=
						jobResp?.data?.results?.preapplied_filters.length || 0;
					// For mobile filters
					props.filters = {
						...props.filters,
						...preAppliedFiltersObject,
					};
				}
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			props.totalJobCount = 0;
			props.jobs = [];
		}

		/**
		 * we use local testiomnials data stored in json if its not older than 1 day
		 * otherwise we fetch testimonials from api which also update locally stored testimonials with new date
		 * so that subsequent requests dont need api calls
		 */

		if (testimonialsData) {
			props.testimonials = testimonialsData.testimonials;
		}

		if (availableVendor) {
			props.availableVendor = availableVendor;
		}

		return {
			props,
		};
	}
	return {
		notFound: true,
	};
};
